var Gifts = {
    lock: false,
    init: function () {
        Api.get("/gifts/getCurrent", {}, function (r) {
            for (var i = 0; i < r.data.length; i++) {
                putHTML(r.data[i]);
            }
        });

        function putHTML(data) {
            //Language.get(['achievements.'+ data.ach +'.name', 'achievements.'+ data.ach +'.description']).then(function(string) {

            var btn;

            if (data.status.isFutureGift === 1) {
                btn =
                    '<button class="button green big disabled">Proximamente</button>';
            } else if (
                (data.status.isCurrentMonth === 1 &&
                    data.status.claimed == 1) ||
                data.status.claimed === 1
            ) {
                btn =
                    '<button class="button green big disabled">Conseguido</button>';
            } else if (
                data.status.isCurrentMonth === 1 &&
                data.status.claimed == 0
            ) {
                btn =
                    '<button class="button green big" onclick="Gifts.exchange();">Reclamar</button>';
            } else if (
                data.status.isFutureGift === 0 &&
                data.status.isCurrentMonth === 0 &&
                data.status.canRecover == 1
            ) {
                btn =
                    '<button class="button green big" onclick="Gifts.recovery(' +
                    data.id +
                    ');">Recuperar</button>';
            } else if (
                data.status.isFutureGift === 0 &&
                data.status.isCurrentMonth === 0
            ) {
                btn =
                    '<button class="button green big disabled">Expirado</button>';
            }

            $("#gifts").append(
                '<div class="box box-biggest"><div class="body" style="display: flex;justify-content: space-between;"><div style="display: flex;align-items: center;"><div style="background-image:url(/images/hexagon_white.png), url(' +
                    data.information.image +
                    ');width: 50px;height: 50px;margin: 0 0 -4px;float: left;background-size: 50px 50px,50px 50px;"></div><div style="display: flex;flex-direction: column;margin-left: 10px;"><span>' +
                    data.information.name +
                    "</span><span>" +
                    data.information.description +
                    "</span></div></div>" +
                    btn +
                    "</div></div>",
            );
        }
    },

    exchange: function () {
        if (!Gifts.lock) {
            Gifts.lock = true;
            Api.post("/gifts/exchange", {}, function (i) {
                if (i.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "El regalo ha sido sumado a tu cuenta.",
                            icon: "check",
                        },
                    ]);
                    $("#gifts").empty();
                    Gifts.init();
                } else {
                    switch (i.error.identifier) {
                        case "already_claimed":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Ya has abierto este regalo.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                        case "club_days_required":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! Debes tener al menos 20 días de suscripción para reclamar este regalo.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                        case "afro_is_required":
                            Alert.push([
                                {
                                    type: "danger",
                                    text: "¡Oops! No eres miembro del Club Afro.",
                                    icon: "triangle-alert",
                                },
                            ]);
                            break;
                    }
                }
                Gifts.lock = false;
            });
        }
    },

    recovery: function (giftId) {
        if (!Gifts.lock) {
            Gifts.lock = true;
            Api.post("/gifts/recovery", { giftId: giftId }, function (i) {
                if (i.success) {
                    Alert.push([
                        {
                            type: "success",
                            text: "El regalo ha sido sumado a tu cuenta.",
                            icon: "check",
                        },
                    ]);
                    $("#gifts").empty();
                    Gifts.init();
                    $("#accounts_recoveries").html(
                        parseInt($("#accounts_recoveries").html()) - 1,
                    );
                }
                Gifts.lock = false;
            });
        }
    },
};
